import React from "react";
import { Modal } from "react-bootstrap";
import OTPInput from "react-otp-input";
import Counter from "../Counter";

const OTPVerify = ({
  passcode,
  passError,
  onChangePasscode,
  resendOtpHandler,
  submitPassCodeHandler,
}) => {
  return (
    <>
      <Modal.Body>
        <p>
          We have sent the OTP verification code to your email address. Check
          your email and enter the code below
        </p>
        <div
          className={
            passError ? "otp-verify-box border-box-red" : "otp-verify-box"
          }
        >
          <OTPInput
            value={passcode}
            onChange={onChangePasscode}
            numInputs={4}
            separator={<span>&ensp;</span>}
            shouldAutoFocus="true"
            renderInput={(props) => <input {...props} />}
          />
        </div>
        {passError && (
          <p className="form-error mt-3 text-center">{passError}</p>
        )}
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-10 text-center">
            <button
              type="button"
              className="btn btn-primary sign-btn mt-3 mb-3"
              onClick={submitPassCodeHandler}
            >
              Continue
            </button>
          </div>
          <div className="col-md-1"></div>
        </div>
        <Counter resendOtpHandler={resendOtpHandler} />
      </Modal.Body>
    </>
  );
};

export default OTPVerify;
